import Vue from 'vue';
import './plugins/axios'
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import VueMask from 'v-mask'
Vue.use(VueMask);
// router setup
import router from './routes/routerGudini';
import i18n from './i18n';
import './registerServiceWorker'
import store from './store'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  i18n
});
